import { useState } from "react";
import { Check, Sprout } from "lucide-react";
import { Reveal, MaskLines } from "./Reveal";
import { SupplyDialog } from "./SupplyDialog";
import { RateBoard } from "./RateBoard";
import { SectionBg } from "./SectionBg";
import { useLang } from "../../lib/i18n";

const Table = ({ title, rows, testId }) => (
  <div data-testid={testId} className="rounded-[24px] border hairline bg-[var(--forest-2)] p-6 sm:p-8">
    <p className="eyebrow mb-4">{title}</p>
    {rows.map(([a, b]) => (
      <div key={a} className="flex justify-between gap-4 border-t hairline py-3.5 text-sm sm:text-base">
        <span>{a}</span>
        <span className="font-mono text-[var(--sage)] text-right">{b}</span>
      </div>
    ))}
  </div>
);

export const Farmers = ({ rates }) => {
  const { t, lang } = useLang();
  const [supplyOpen, setSupplyOpen] = useState(false);
  return (
  <section id="farmers" data-testid="farmers-section" className="relative overflow-hidden py-24 sm:py-36 border-t hairline">
    <SectionBg src="/images/farmer-harvest.jpg" position="center 30%" opacity={0.8} testId="farmers-bg" />
    <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8 grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-6">
        <p className="eyebrow mb-5">{t("farm.eyebrow")}</p>
        <h2 key={lang} className="font-display font-bold tracking-[-0.03em] leading-[0.95] text-5xl sm:text-6xl">
          <MaskLines inView lines={[t("farm.h1"), <span key="b">{t("farm.pre")}<span className="font-serif-i font-normal text-[var(--husk)]">{t("farm.accent")}</span></span>]} delay={0} />
        </h2>
        <Reveal>
          <ul className="mt-10 space-y-4">
            {t("farm.points").map((p) => (
              <li key={p} className="flex gap-3 text-[var(--cream)]"><Check className="h-5 w-5 mt-0.5 text-[var(--mint)] shrink-0" />{p}</li>
            ))}
          </ul>
          <button data-testid="farmer-supply-btn" onClick={() => setSupplyOpen(true)} className="group mt-10 inline-flex items-center gap-2 rounded-full bg-[var(--husk)] text-[var(--forest)] px-6 py-3.5 font-semibold transition-transform hover:-translate-y-0.5">
            <Sprout className="h-4 w-4 transition-transform group-hover:-rotate-12" /> {t("farm.email")}
          </button>
        </Reveal>
      </div>
      <div className="lg:col-span-6 grid gap-5">
        <Reveal><RateBoard rates={rates} /></Reveal>
        <Reveal><Table title={t("farm.buyTitle")} rows={t("farm.buy")} testId="buy-table" /></Reveal>
        <Reveal delay={0.1}><Table title={t("farm.specTitle")} rows={t("farm.spec")} testId="spec-table" /></Reveal>
      </div>
    </div>
    <SupplyDialog open={supplyOpen} onOpenChange={setSupplyOpen} />
  </section>
  );
};
